




















































import Vue from "vue";
import iwModal from "@/shared/components/Modal.vue";
import { mapState } from "vuex";
import { Step, StepsGroup } from "@/shared/interfaces/Step.interface";
import { ApiError } from "@/shared/interfaces/ApiError";


export default Vue.extend({
    components: {
        iwModal: iwModal
    },

    computed: {
        ...mapState("StepsWizard", ["groups", "steps"]),
        ...mapState("FormModule", ["errors"]),
        isWarningModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isWarningModalOpen"];
        },
        stepsWithError: function (): Array<Step> {
            return this.groups.flatMap((group: StepsGroup) => {
                if(group.isGroup) {
                    return group.steps;
                } else {
                    return group;
                }
            }).filter((step: Step) => step.error);
        },
        errorDetails: function(): Array<ApiError> {
            const warningEntries = this.errors?.warnings || [];
            const errorEntries = this.errors?.errors || [];
            return [...warningEntries, ...errorEntries]
                .filter((entry: ApiError) => Boolean(entry?.description || entry?.property));
        }
    },

    methods: {
        closeWarningModal: function() {
            this.$store.commit("ModalModule/closeWarningModal");
        },
        redirectToStep: function(stepname: string) {
            this.closeWarningModal();
            this.routeToPage(stepname);
        }
    }
});

